import { isNil } from 'lodash';
import Link from 'next/link';
import { FC, ReactNode } from 'react';

import { IconArrowLeft } from 'src/general/Icons/IconArrowLeft';
import { Button } from 'src/general/components/Button/Button';
import { ButtonIcon } from 'src/general/components/Button/ButtonIcon';

import classes from './AuthFormHeader.module.scss';

interface Props {
  title?: ReactNode;
  subtitle?: ReactNode;
  onBack?: () => void;
}

export const AuthFormHeader: FC<Props> = ({ title, subtitle, onBack }) => (
  <header className={classes.root}>
    <Link href="/">
      <img
        className={classes.logo}
        src="/images/carma-logo-wordmark.svg"
        alt="Carma"
        width="150"
        height="52"
        loading="lazy"
      />
    </Link>
    {!isNil(title) && <h1 className={classes.title}>{title}</h1>}
    {!isNil(subtitle) && <div className={classes.subtitle}>{subtitle}</div>}
    {!isNil(onBack) && (
      <div className={classes.backContainer}>
        <ButtonIcon
          Icon={IconArrowLeft}
          onClick={onBack}
          title="Back"
          variant="tertiary"
          size="small"
          className={classes.backMobile}
          data-testid="AuthFormHeader-component-backIcon"
        />
        <Button
          startIcon={<IconArrowLeft />}
          onClick={onBack}
          variant="tertiary"
          className={classes.backDesktop}
          data-testid="AuthFormHeader-component-backButton"
        >
          Back
        </Button>
      </div>
    )}
  </header>
);
